import { useEffect } from 'react';

const SITE_ORIGIN = 'https://www.trados.app';

/**
 * Sets a self-referencing <link rel="canonical"> for the current route.
 * index.html ships no canonical tag, so every public SPA page inherits
 * none unless it sets its own here.
 * @param {string} path - absolute path of the current page, e.g. "/verify-loi"
 */
const useCanonical = (path) => {
  useEffect(() => {
    if (!path) return undefined;
    const href = `${SITE_ORIGIN}${path}`;
    let link = document.querySelector('link[rel="canonical"]');
    const existed = !!link;
    const previousHref = link ? link.getAttribute('href') : null;
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', href);

    return () => {
      if (!existed) {
        link.remove();
      } else if (previousHref) {
        link.setAttribute('href', previousHref);
      }
    };
  }, [path]);
};

export default useCanonical;
